import { useCallback, useEffect, useRef, useState } from 'react';

export function useCountdown(initialCount: number, onComplete: () => void) {
  const [count, setCount] = useState(initialCount);
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const startCountdown = useCallback(() => {
    setCount(initialCount);

    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onCompleteRef.current();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, [initialCount]);

  return { count, startCountdown };
}
